module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAGhJREFUeNpiNDY29mRgYJgLxJIMpIHnQJzMRKZmBqieuSxImhlJNOA/SC8TA4Vg8BlwGOo3ZHyYUhfgDVwWNL7t0A9EmsQC3lghxwWMo7GAacBzpPxNCgaBFyADUkAMMix/CirSAAIMAER4JYFwKbrYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_information.png
// module id = TqHC
// module chunks = 2